import IGestionFacturation from "../../models/IGestionFacturation";
import DataGrid, {Column, DataGridRef, Editing, Item, Lookup, Paging, RowDragging, Scrolling, Toolbar} from "devextreme-react/data-grid";
import React, {useCallback, useMemo, useRef} from "react";
import IFacturationDetail from "../../models/IFacturationDetail";
import useApi from "../../hooks/useApi";
import IFolio from "../../models/IFolio";
import useLookUpBase from "../../components/selectbox/LookupBase";
import IReservationDetailSommaire, {ReservationDetailSommaireTypeAuxiliaire} from "../../models/IReservationDetailSommaire";
import Guid from "../../models/Guid";
import GestionFacturation from "./gestion-facturation";
import {Mode} from "../../hooks/useCustomDataSource";
import {Button} from "devextreme-react";
import {IonIcon} from "@ionic/react";
import {cardOutline, personAdd} from "ionicons/icons";
import CustomStore from "devextreme/data/custom_store";
import {LoadFunctionResult, LoadOptions} from "devextreme/common/data";
import {LoadResult} from "rollup";
import DataSource from "devextreme/data/data_source";
import IDataSource from "../../models/IDataSource";
import IFacturationList from "../../models/IFacturationList";
import {useAuth} from "../../contexts/auth";
import {InitNewRowEvent} from "devextreme/ui/data_grid";
import IGestionReservation from "../../models/IGestionReservation";
import ILookupItem from "../../models/ILookupItem";
import ICatalogue from "../../models/ICatalogue";
import IReservationEquipement from "../../models/IReservationEquipement";
import IReservationDetailOccupant from "../../models/IReservationDetailOccupant";
import IOptionReservation from "../../models/OptionReservation";

export default function GestionFacturationDetail({selectedDataRow, mode, setIsFieldModifier, setSelectedDataRow}: IDataSource<IFacturationList, IGestionFacturation>) {
    const {editorOptions: folioEditorOptions} = useLookUpBase({controllerName: 'folio'})
    const {editorOptions: planEditorOptions} = useLookUpBase({controllerName: "planentete", includeEmpty: false})
    const {data: typeUnites} = useLookUpBase({controllerName: "typeunite"});
    const {data: catalogues, editorOptions: catalogueEditorOptions, PopupGestion: CataloguePopGestion} = useLookUpBase({controllerName: "catalogue", showClear: false, includeEmpty: false})
    const {data: unites} = useLookUpBase({controllerName: "unite"})
    const dataGridRef = useRef<DataGridRef>(null)
    const {postData: postFacturationDetail} = useApi<IFacturationDetail>("FacturationDetail");
    const {user} = useAuth();
    const ajouterButtonOtions = useMemo(() => ({
        icon: 'plus',
        text: "Ajouter détail",
        disabled: mode === Mode.Lecture,
        onClick: () => {
            dataGridRef?.current?.instance().addRow()
        }

    }), [mode])

    const effacerButtonOtions = useMemo(() => ({
        icon: 'remove',
        text: "Effacer",
        disabled: mode === Mode.Lecture,
    }), [mode])

    const personnesAssocieesButtonOtions = useMemo(() => ({
        icon: 'group',
        text: "Personne associées",
        onClick: () => {

        }

    }), [mode])
    const carteMembreButtonOtions = useMemo(() => ({
        icon: 'print',
        text: "Carte de membre",
        onClick: () => {

        }

    }), [mode])
    const encoderCarteButtonOtions = useMemo(() => ({
        icon: 'card-outline',
        text: "Encoder la carte",
        onClick: () => {

        }

    }), [mode])

    const lookupTypeAuxiliairedataSource = useMemo(() => [{id: Guid.max, description: "Produit"}, ...(typeUnites || []).filter((f => !f.id.equals(Guid.max)))], [typeUnites]);
    const setTypeAuxiliaireCellValue = useCallback((newData: any, value: any, currentRowData: IFacturationDetail) => {
        newData.idTypeUnite = value
    }, [mode]);

    const uniteProduitCellComponent = useCallback((e: any) => {
        if (!e.data?.data) return;
        const row = e.data.data as IFacturationDetail;
        const isUnite = !row?.idUnite?.equals(Guid.empty);
        const data = isUnite ? (unites || []).find(f => f.id.equals(e.data.value)) : (catalogues || []).find(f => f.id.equals(e.data.value))
        return <div title={data?.description}>
            {row?.description}
        </div>
    }, [unites, catalogues])

    const uniteProduitSetCellValue = useCallback((newData: IFacturationDetail, value: any, currenRowData: IFacturationDetail) => {
        if (value instanceof Guid)
            newData.idUnite = value
        else
            newData.description = value
    }, []);

    const dataGridStore = useMemo(() => new CustomStore({
        key: 'idFacturationDetail',
        byKey(key: Guid, extraOptions: LoadOptions<IFacturationDetail> | undefined): PromiseLike<IFacturationDetail> {
            return Promise.resolve(selectedDataRow?.facturationDetails?.find(f => f.idFacturationDetail.equals(key)) || {} as IFacturationDetail);
        },
        insert: (values: IFacturationDetail): PromiseLike<IFacturationDetail> => {
            return Promise.resolve(postFacturationDetail({SelectedDataRow: values, idUsager: user?.idUsager}, 'facturation/CreateOrUpdateFacturationDetail').then((newRow) => {
                const result = {...values, ...newRow};
                setSelectedDataRow((prev) => {
                    return {
                        ...prev,
                        facturationDetails: [...prev?.facturationDetails || [], newRow],
                    } as IGestionFacturation;
                })
                setIsFieldModifier(true)
                return result;
            }));
        },
        load: async (options: LoadOptions<IFacturationDetail>) => {
            return {data: selectedDataRow?.facturationDetails || [] as IFacturationDetail[], totalCount: selectedDataRow?.facturationDetails?.length || 0};
        },
        remove(key: Guid): PromiseLike<void> {
            setIsFieldModifier(true);
            setSelectedDataRow(prev => {
                return {
                    ...prev, facturationDetails: prev.facturationDetails.filter(f => f.idFacturationDetail.equals(key))
                        .map(f => ({...f, dateSuppression: new Date(), idUsagerSuppression: user?.idUsager, isDeleted: true}))
                }
            })
            return Promise.resolve();
        },
        async update(key: Guid, values: IFacturationDetail) {
            const currentRow = {...selectedDataRow.facturationDetails.find(f => f.idFacturationDetail.equals(key)), ...values};
            const rowUpdated = await postFacturationDetail({SelectedDataRow: currentRow, idUsager: user?.idUsager}, 'facturation/CreateOrUpdateFacturationDetail');
            setSelectedDataRow(prev => {
                return {
                    ...prev, facturationDetails: [...prev.facturationDetails.filter(f => !f.idFacturationDetail.equals(key)), rowUpdated]
                }
            })
            setIsFieldModifier(true);
            return rowUpdated;
        }
    }), [selectedDataRow])

    const dataGridDetailDataSource = useMemo(() => new DataSource({
        key: 'idFacturationDetail',
        store: dataGridStore,
        reshapeOnPush: true
    }), [dataGridStore])

    const onInitNewRow = (e: InitNewRowEvent<IFacturationDetail, any>) => {
        const facturationDetail = {
            ...e.data,
            idFacturationEntete: selectedDataRow?.idFacturationEntete,
            idTypeUnite: Guid.max,
            qteVendues: 1
        } as IFacturationDetail;
        e.promise = postFacturationDetail({
            selectedDataRow: facturationDetail,
            idUsage: user?.idUsager
        }, 'facturation/CreateOrUpdateFacturationDetail', true)
            .then((newRow) => {
                e.data = newRow;
            });
    };
    const onDragStart = useCallback((e: any) => e.cancel = true, [])
    const OnAdd = useCallback(async (e: any) => {
        const {selectedProduit} = e.itemData as {
            selectedProduit: (ICatalogue & { quantite?: number })[],
        };

        if (selectedProduit) {
            for (const produit of selectedProduit) {
                const facturationDetail: IFacturationDetail = {
                    idProduit: produit.idProduit,
                    dateCreation: new Date(),
                    dateModification: new Date(),
                    dateSuppression: undefined,
                    idUsagerCreation: user?.idUsager,
                    idUsagerModification: user?.idUsager,
                    idUsagerSuppression: undefined,
                    idClient: selectedDataRow?.idClient || Guid.empty,
                    idTypeUnite: Guid.max,
                    isDeleted: false
                } as IFacturationDetail;

                /* await postReservationDetailSommaire({
                     ReservationDetailSommaire: {...facturationDetail, idReservationEntete: selectedReservation?.idReservationEntete} as IReservationDetailSommaire,
                     IdUsager: user?.idUsager
                 }, 'reservationDetailSommaire/CreateOrUpdateRow', true).then((newRow) => {
                     newReservationDetailSommaire.push(newRow)
                 });*/

            }
        }
        setIsFieldModifier(true)

    },[])

    return <DataGrid ref={dataGridRef} dataSource={dataGridDetailDataSource} onInitNewRow={onInitNewRow}>
        <Toolbar>
            <Item widget={"dxButton"} location={"before"} options={ajouterButtonOtions}/>
            <Item widget={"dxButton"} location={"before"} options={effacerButtonOtions}/>
            <Item widget={"dxButton"} location={"before"} options={personnesAssocieesButtonOtions}/>
            <Item widget={"dxButton"} location={"before"} options={carteMembreButtonOtions}/>
            <Item widget={"dxButton"} location={"before"} options={encoderCarteButtonOtions}>
                <Button stylingMode={"text"}>
                    <IonIcon icon={cardOutline}/>
                    <span style={{paddingInline: "4px"}} className="dx-button-text">{encoderCarteButtonOtions.text}</span>
                </Button>
            </Item>
        </Toolbar>
        <RowDragging onDragStart={onDragStart} group={"ajoutRapid"} allowReordering={false} showDragIcons={false} allowDropInsideItem={mode !== Mode.Lecture} onAdd={OnAdd}/>
        <Editing allowAdding={mode !== Mode.Lecture} allowDeleting={true} allowUpdating={mode !== Mode.Lecture} newRowPosition={"first"} mode={"cell"} startEditAction={"click"}/>
        <Scrolling showScrollbar={"always"}/>
        <Paging enabled={false}/>
        <Column dataField={"idTypeUnite"} dataType={"object"} caption={"Type unité"} width={"10%"} setCellValue={setTypeAuxiliaireCellValue}>
            <Lookup valueExpr={"id"} displayExpr={"description"} dataSource={lookupTypeAuxiliairedataSource}/>
        </Column>
        <Column caption={"Date d'arrivée"} width={100} calculateCellValue={(data: IFacturationDetail) => {
            const reservationDetail = selectedDataRow?.reservation?.reservationDetailSommaires
                .flatMap(detailReservation => detailReservation.reservationDetails)
                .find(f => f.idReservationDetail.equals(data.idReservationDetail));
            return reservationDetail?.dateDebut;
        }}/>
        <Column caption={"Date de départ"} width={100} calculateCellValue={(data: IFacturationDetail) => {
            const reservationDetail = selectedDataRow?.reservation?.reservationDetailSommaires
                .flatMap(detailReservation => detailReservation.reservationDetails)
                .find(f => f.idReservationDetail.equals(data.idReservationDetail));
            return reservationDetail?.dateFin;
        }}/>
        <Column dataField={"idProduit"} caption={"Code"}>
            <Lookup {...catalogueEditorOptions} displayExpr={"code"}/>
        </Column>
        <Column
            caption={"Description"}
            dataField={"idUnite"}
            dataType={"object"}
            alignment={"center"}
            cellComponent={uniteProduitCellComponent}
            setCellValue={uniteProduitSetCellValue}
        >
            <Lookup valueExpr={"id"} displayExpr={"description"}/>
        </Column>
        <Column dataField={"idPlanEntete"} caption={"Plan"}>
            <Lookup {...planEditorOptions}/>
        </Column>
        <Column dataField={"idFolio"} dataType={"object"} caption={"Folio"}>
            <Lookup {...folioEditorOptions}/>
        </Column>
        <Column width={"3.1rem"} dataType={"number"} dataField={"nombrePersonnes"} caption={"Nb.Pers"} format={"0"}/>
        <Column width={"3rem"} dataType={"number"} dataField={"qteVendues"} caption={"Qté"} format={"#0.00"}/>
        <Column dataType={"number"} dataField={"prixUnitaire"} caption={"Prix"} format={"#0.00 $"}/>
        <Column width={"4rem"} dataType={"number"} dataField={"escompte"} caption={"Escompte"} format={"#0.00 %"}/>
        <Column dataType={"number"} caption={"Total Av. Tx."} calculateCellValue={(e: IFacturationDetail) => e.qteVendues * e.prixUnitaire} format={"#0.00 $"}/>
        <Column type="buttons" width={32}/>
    </DataGrid>;
}